<template>
  <div>
    <Request :type="getActiveType">
      <component :is="child_component"></component>
    </Request>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Request from "../../requests/Request";
import ContactBlock from "./ContactBlock"; // local contact block passed as slot to Request
export default {
  components: {
    Request,
    ContactBlock
  },
  data() {
    return {
      child_component: "ContactBlock"
    };
  },
  computed: {
    ...mapGetters(["getActiveType"])
  }
};
</script>

<style scoped>
</style>